import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapState, mapGetters } from 'vuex';

export default {
    data: function data() {
        return {
            noExpandTable: false,
            paginationranking: {},
            headers: [{
                text: '#',
                align: 'left',
                value: 'position'
            }, {
                text: 'Ranking vendedores',
                align: 'left',
                value: 'Seller'
            }, { text: 'POS Inalam.', value: 'POSInalam', align: 'right' }, { text: 'POS Fijo', value: 'POSFijo', align: 'right' }, { text: 'Pago Web', value: 'PagoWEB', align: 'right' }, { text: 'Pago App', value: 'PagoAPP', align: 'right' }, { text: 'Pago Link', value: 'PagoLink', align: 'right' }, { text: 'Total Afiliaciones', value: 'result', align: 'right' }],
            itemsPerPage: [10, 25, { "text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1 }],
            showPaginator: false
        };
    },

    methods: {
        showMoreTable: function showMoreTable() {
            this.noExpandTable = true;
            this.showPaginator = true;
        },
        pagination: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(val) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.$store.dispatch('dashboard/table/search', {
                                    type: 'Process',
                                    limit: val.pageSize,
                                    paginationNumber: val.pageNumber
                                });

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function pagination(_x) {
                return _ref.apply(this, arguments);
            }

            return pagination;
        }()
    },
    computed: _extends({}, mapGetters({
        totalItems: 'dashboard/table/totalItemsRanking'
    }), mapState({
        emptyTable: function emptyTable(state) {
            return state.dashboard.table.emptyTable;
        },
        removeFilter: function removeFilter(state) {
            return state.dashboard.table.affiliations.removeFilter;
        },
        affiliationsRanking: function affiliationsRanking(state) {
            return state.dashboard.table.affiliationsRanking || [];
        }
    }), {
        showBtn: function showBtn() {
            return this.affiliationsRanking.length > 5 && !this.showPaginator;
        }
    })
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/ranking-table.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/ranking-table.vue
// module chunks = 5